import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export default function ToolFormDialog({
  open,
  onOpenChange,
  form,
  setForm,
  onSave,
  isEdit,
}) {
  const update = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>{isEdit ? "Edit tool" : "Add tool"}</DialogTitle>
          <DialogDescription>
            Vibration magnitude (m/s²) is used to compute HSE points.
          </DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <Label>Tool code</Label>
            <Input
              value={form.code}
              onChange={update("code")}
              disabled={isEdit}
              data-testid="tool-form-code"
            />
          </div>
          <div>
            <Label>Name</Label>
            <Input
              value={form.name}
              onChange={update("name")}
              data-testid="tool-form-name"
            />
          </div>
          <div>
            <Label>Model</Label>
            <Input
              value={form.model}
              onChange={update("model")}
              data-testid="tool-form-model"
            />
          </div>
          <div>
            <Label>Vibration (m/s²)</Label>
            <Input
              type="number"
              step="0.1"
              value={form.vibration_m_s2}
              onChange={update("vibration_m_s2")}
              data-testid="tool-form-vibration"
            />
          </div>
          <div className="col-span-2">
            <Label>Category</Label>
            <Input
              value={form.category}
              onChange={update("category")}
              placeholder="e.g. Breaker, Drill, Grinder"
              data-testid="tool-form-category"
            />
          </div>
          <div className="col-span-2">
            <Label>Notes / data source</Label>
            <Textarea
              rows={3}
              value={form.notes}
              onChange={update("notes")}
              data-testid="tool-form-notes"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            onClick={onSave}
            className="bg-slate-900 hover:bg-slate-800"
            data-testid="tool-form-save"
          >
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
